import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';

var NAMESPACE = 'td';

var BreadCrumb = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-breadcrumb" }, [_c('div', { staticClass: "td-breadcrumb__items" }, [_c('div', { staticClass: "td-breadcrumb__item" }, [_c('span', { staticClass: "td-breadcrumb__text", on: { "click": function click($event) {
          return _vm.handleClickShrinkRouteListItem(-1);
        } } }, [_c('a', { attrs: { "href": "javascript:;" } }, [_vm._v(_vm._s(_vm.fullRoutes[0].title))])]), _vm._v(" "), _c('span', { directives: [{ name: "show", rawName: "v-show", value: _vm.shrinkRouteList.length, expression: "shrinkRouteList.length" }], staticClass: "td-breadcrumb__separator" }, [_c('i', { staticClass: "td-icon-arrow-right" })])]), _vm._v(" "), _c('div', { staticClass: "td-breadcrumb__item" }, [_c('div', { directives: [{ name: "show", rawName: "v-show", value: _vm.shrinkRouteList.length, expression: "shrinkRouteList.length" }], staticClass: "td-select" }, [_vm._m(0), _vm._v(" "), _c('div', { directives: [{ name: "show", rawName: "v-show", value: _vm.shrinkSelectVisible, expression: "shrinkSelectVisible" }], staticClass: "td-dropdown-menu" }, [_c('ul', _vm._l(_vm.shrinkRouteList, function (route, index) {
      return _c('li', { key: route.id + index, staticClass: "td-dropdown-menu__item", attrs: { "title": route.title }, on: { "click": function click($event) {
            return _vm.handleClickShrinkRouteListItem(index);
          } } }, [_vm._v(" " + _vm._s(route.title) + " ")]);
    }), 0)])]), _vm._v(" "), _c('span', { directives: [{ name: "show", rawName: "v-show", value: _vm.restRouteList.length, expression: "restRouteList.length" }], staticClass: "td-breadcrumb__separator" }, [_c('i', { staticClass: "td-icon-arrow-right" })])]), _vm._v(" "), _vm._l(_vm.restRouteList, function (route, index) {
      return _c('div', { key: route.id + index, staticClass: "td-breadcrumb__item" }, [index === _vm.restRouteList.length - 1 ? [_c('div', { staticClass: "td-breadcrumb__item" }, [_c('span', { staticClass: "td-breadcrumb__text", attrs: { "title": route.title } }, [_vm._v(_vm._s(route.title))])])] : [_c('div', { staticClass: "td-breadcrumb__item" }, [_c('span', { staticClass: "td-breadcrumb__text", attrs: { "title": route.title }, on: { "click": function click($event) {
            return _vm.handleClickRestRouteListItem(index);
          } } }, [_c('a', { attrs: { "href": "javascript:;" } }, [_vm._v(_vm._s(route.title))])]), _vm._v(" "), _vm._m(1, true)])]], 2);
    })], 2)]);
  }, staticRenderFns: [function () {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-select-group" }, [_c('span', { staticClass: "td-select-group__label" }), _vm._v(" "), _c('a', { staticClass: "td-select__drop", attrs: { "href": "javascript:;" } }, [_c('i', { staticClass: "td-icon-arrow-drop" })])]);
  }, function () {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('span', { staticClass: "td-breadcrumb__separator" }, [_c('i', { staticClass: "td-icon-arrow-right" })]);
  }],
  name: NAMESPACE + '-breadcrumb',
  props: {
    initRouteList: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      shrinkListVisible: false,
      shrinkSelectVisible: false,
      shrinkRouteList: [],
      restRouteList: []
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      this.shrinkRouteList = this.initRouteList.slice(1);
      this.restRouteList = [];
      this.$nextTick(function () {
        _this.autoExpandAlign();
      });
    },
    handleClickDropdown: function handleClickDropdown() {
      this.shrinkSelectVisible = !this.shrinkSelectVisible;
    },
    autoShrinkAlign: function autoShrinkAlign() {
      var _this2 = this;

      var _$el = this.$el,
          offsetWidth = _$el.offsetWidth,
          scrollWidth = _$el.scrollWidth;

      if (scrollWidth > offsetWidth && this.restRouteList.length) {
        this.shrinkRouteList.push(this.restRouteList.shift());
        this.$nextTick(function () {
          _this2.autoShrinkAlign();
        });
      }
    },
    autoExpandAlign: function autoExpandAlign() {
      var _this3 = this;

      var _$el2 = this.$el,
          offsetWidth = _$el2.offsetWidth,
          scrollWidth = _$el2.scrollWidth;

      if (scrollWidth <= offsetWidth && this.shrinkRouteList.length) {
        this.restRouteList.unshift(this.shrinkRouteList.pop());
        this.$nextTick(function () {
          _this3.autoExpandAlign();
        });
      } else {
        this.autoShrinkAlign();
      }
    },
    handleClickRestRouteListItem: function handleClickRestRouteListItem(index) {
      var originalRoute = [].concat(_toConsumableArray(this.fullRoutes));
      this.restRouteList = this.restRouteList.slice(0, index + 1);
      this.$emit('onRoutelistChange', this.fullRoutes, originalRoute);
    },
    handleClickShrinkRouteListItem: function handleClickShrinkRouteListItem(index) {
      var originalRoute = [].concat(_toConsumableArray(this.fullRoutes));
      this.restRouteList = [];
      this.shrinkRouteList = this.shrinkRouteList.slice(0, index + 1);
      this.$emit('onRoutelistChange', this.fullRoutes, originalRoute);
    }
  },
  computed: {
    fullRoutes: function fullRoutes() {
      return [this.initRouteList[0]].concat(_toConsumableArray(this.shrinkRouteList), _toConsumableArray(this.restRouteList));
    }
  },
  mounted: function mounted() {
    if (process.env.NODE_ENV !== 'production') {
      if (!this.initRouteList.every(function (item) {
        return item['title'] && item['id'];
      })) {
        console.error('Every item of InitRouteList should have id and title');
      }
    }
    try {
      this.restRouteList = JSON.parse(_JSON$stringify(this.initRouteList));
    } catch (e) {
      console.warn(e);
    }
    this.init();
  },

  watch: {
    'initRouteList': {
      handler: function handler(newVal, oldVal) {
        this.init();
      }
    }
  }
};

BreadCrumb.install = function (Vue) {
  Vue.component(BreadCrumb.name, BreadCrumb);
};

export default BreadCrumb;
